// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Navbar_toolbar__1M85O","active":"Navbar_active__3mbhk","appbar":"Navbar_appbar__MoDCQ","icon":"Navbar_icon__11DLx","toggleIcon":"Navbar_toggleIcon__2oXKa"};